import React, { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import moment from 'moment';

import { Text } from '../../../../components/Text';
import { TitleSections } from '../../../../components/TitleSections';
import InfoArrendatarioLeitura from './infoArrendatarioLeitura';
import InfoArrendatarioEdicao from './infoArrendatarioEdicao';
import { useAuth } from '../../../../hooks/auth';

export function InfoArrendatario({
  dadosArrend,
  carregarSolicitacaoAtual,
  setSpinning,
  tipoValidacao,
}) {
  const titituloSecaoArrend = dadosArrend?.detalheTipoCadastro;
  const [readOnly, setReadOnly] = useState(true);

  const [isAdministrador, setIsAdministrador] = useState(false);
  const { temPermissao } = useAuth();
  useEffect(() => {
    const isAdmin =
      temPermissao(['EditarCadastroPainel']) && tipoValidacao === 1;
    setIsAdministrador(isAdmin);
  }, [temPermissao]);

  return (
    <>
      <TitleSections
        title={`Dados cadastrais do ${titituloSecaoArrend} `}
        withButton={!!isAdministrador}
        buttonTitle="Editar"
        setReadOnly={setReadOnly}
        readOnly={readOnly}
        // textColorButton="#828282"
      />
      <Row
        justify="space-between"
        style={{
          display: 'flex',
          width: '100%',
          flexDirection: 'column',
          marginTop: 32,
        }}
      >
        {readOnly ? (
          <InfoArrendatarioLeitura dadosArrend={dadosArrend} />
        ) : (
          <InfoArrendatarioEdicao
            dadosArrend={dadosArrend}
            carregarSolicitacaoAtual={carregarSolicitacaoAtual}
            setSpinning={setSpinning}
            setReadOnly={setReadOnly}
          />
        )}
      </Row>
    </>
  );
}
